












import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RegistrationError } from '@/interfaces/registration/RegistrationError';
import lodash from 'lodash';
const registration = namespace('registration');

@Component
export default class RegistrationErrorSummary extends Vue {
  @registration.State
  public registrationErrors!: Array<RegistrationError>;

  public showMore = false;

  get errors (): Array<string | undefined> {
    return lodash.flatten(lodash.map(this.registrationErrors, (error) => error.errors));
  }
}
